import { render, staticRenderFns } from "./UidLogin.vue?vue&type=template&id=5345fc4a&scoped=true&"
import script from "./UidLogin.vue?vue&type=script&lang=js&"
export * from "./UidLogin.vue?vue&type=script&lang=js&"
import style0 from "./UidLogin.vue?vue&type=style&index=0&id=5345fc4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345fc4a",
  null
  
)

export default component.exports